/* eslint-disable react/prop-types */
import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { defaults } from "react-chartjs-2";
import { Chart } from "chart.js";

const Horizontal = props => {
  const [chart, setChart] = useState({});
  const [displayTitle] = useState(true);
  const [displayLegend] = useState(true);
  var [legendPosition] = useState("right");
  // var [location] = useState("City");
  var [tap] = useState("");
  // var [option2] = useState("");
  // var [option3] = useState("");
  // var [option4] = useState("");
  // var [option5] = useState("");
  const [name, setName] = useState("");

  // if (props.location !== null) {
  //   location = props.location;
  // }
  if (props.legendPosition !== null) {
    legendPosition = props.legendPosition;
  }

  // const monthNames = [
  //   "มกราคม",
  //   "กุมภาพันธ์",
  //   "มีนาคม",
  //   "เมษายน",
  //   "พฤษภาคม",
  //   "มิถุนายน",
  //   "กรกฎาคม",
  //   "สิงหาคม",
  //   "กันยายน",
  //   "ตุลาคม",
  //   "พฤศจิกายน",
  //   "ธันวาคม"
  // ];

  // const chartData = () => {
  //   setChartData(props.chartData);
  // };

  useEffect(() => {
    if (props.topTen) {
      axios(
        "/api/v1/data/topTen?tap=" +
          tap +
          "&year=" +
          props.year +
          "&month=" +
          props.month,
        {
          method: "GET"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            if ((result.data.datasets.length = 1 && props.name !== "")) {
              var calYear = 0;
              if (props.year === "" || props.year === 0) {
                var dateObj = new Date();
                var month = dateObj.getUTCMonth() + 1; //months from 1-12
                // var day = dateObj.getUTCDate();
                var year = dateObj.getUTCFullYear() + 543;
                //newdate = year + "/" + month + "/" + day;]
                if (month > 9) {
                  calYear = year + 1;
                }
                calYear = year;
              } else {
                calYear = props.year;
              }

              var sMonth = "";
              if (props.month !== "" && props.month !== 0) {
                var calMonth = "";
                if (props.month === 1) {
                  calMonth = "ตุลาคม";
                } else if (props.month === 2) {
                  calMonth = "พฤศจิกายน";
                } else if (props.month === 3) {
                  calMonth = "ธันวาคม";
                } else if (props.month === 4) {
                  calMonth = "มกราคม";
                } else if (props.month === 5) {
                  calMonth = "กุมภาพันธ์";
                } else if (props.month === 6) {
                  calMonth = "มีนาคม";
                } else if (props.month === 7) {
                  calMonth = "เมษายน";
                } else if (props.month === 8) {
                  calMonth = "พฤษภาคม";
                } else if (props.month === 9) {
                  calMonth = "มิถุนายน";
                } else if (props.month === 10) {
                  calMonth = "กรกฎาคม";
                } else if (props.month === 11) {
                  calMonth = "สิงหาคม";
                } else if (props.month === 12) {
                  calMonth = "กันยายน";
                }
                sMonth = " เดือน " + calMonth;
                //monthNames[d.getMonth()
              }

              setName(props.name + " " + calYear + sMonth);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.topTen, props.month, props.year]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.other) {
      axios(
        "/api/v1/data/barOtherHorizontal?data=" +
          props.data +
          "&year=" +
          props.year,
        {
          method: "GET"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            if (props.name !== "") {
              setName(props.name);
            } else {
              setName("");
            }
            setChart(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [props.other, props.year]);

  defaults.global.defaultFontFamily = '"Sarabun", sans-serif';

  return (
    <div className="chart">
      <HorizontalBar
        data={chart}
        options={{
          title: {
            display: displayTitle,
            text: name,
            fontSize: 25
          },
             legend: {
                display: displayLegend,
                position: legendPosition
              },
              hover: {
                animationDuration: 10
              },
              animation: {
                duration: 1,
                onComplete: function() {
                  var chartInstance = this.chart,
                    ctx = chartInstance.ctx;
                    ctx.font = Chart.helpers.fontString(
                    "10",
                    "normal",
                    '"Sarabun", sans-serif'
                  );
                  ctx.textAlign = "center";
                  ctx.textBaseline = "bottom";
                  ctx.fillStyle = "Black";

                  //ตัวเลขบน chart
                  this.data.datasets.forEach(function(dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function(bar, index) {
                      var data = dataset.data[index];
                      ctx.fillText(data, bar._model.x, bar._model.y - 5);
                    });
                  });
                }
              }
        }}
      />
    </div>
  );
};

export default Horizontal;
